<template>
  <div>
    <button
      class="btn btn-outline-dark btn-sm"
      @click="hideQuestionImage"
    >
      <span>
        <span v-if="slideActive.showQuestionImage">Hide </span>
        <span v-else>Show </span>
        image
      </span>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    hideQuestionImage() {
      const { showQuestionImage } = this.slideActive
      this.updateSlideActiveAction({
        showQuestionImage: !showQuestionImage,
      })
      if (this.sharePresentation) {
        return
      }
      this.$emit('updateSlide', {
        accessCode: this.presentation.uniqueAccessCode,
        showQuestionImage: this.slideActive.showQuestionImage,
      }, 4)
    },
  },
}
</script>
